import { toast } from 'react-toastify'
import { fetchJitsiToken } from '../../../services/AppointmentServices'
import { AppointmentData } from '../appointmentsSlice'
import { constants, sucessErrorMsg } from '../../../services/constants'

type Props = {
  appointment: AppointmentData
}

const MeetingLink = ({ appointment }: Props) => {
  const joinMeeting = async (url: string) => {
    if (!url) {
      toast.warning(sucessErrorMsg?.meetingLinkErrorMsg)
      return
    }
    const jitsiToken = await fetchJitsiToken()
    const meetingUrl = jitsiToken ? `${url}?jwt=${jitsiToken}` : url

    if (!jitsiToken) {
      toast.warning(sucessErrorMsg?.recordingUnavailableMsg)
    }
    window.open(meetingUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <button
      className='meetingLink'
      onClick={() => joinMeeting(appointment?.meetingLink)}
    >
      {constants?.joinMeeting}
    </button>
  )
}

export default MeetingLink
